export const VERSION='release:v2.6.21 ref:7e86a73cdf61b3b1abc4a9b2f5636297dedcd9e7 date:2026-05-21T13:43:20Z';
